import API from "./../common/api";
import Fetch from "./fetch";

let fetchEnvironmentPromise = null;
export function fetchEnvironment(forceNoCache) {
	if (forceNoCache || fetchEnvironmentPromise === null) {
		fetchEnvironmentPromise = Fetch.get(`${API.GENERAL.SHOW_INFO}`);
	}

	return fetchEnvironmentPromise;
}
